import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'

export const MarqueeVerticalWithoutBox = (): JSX.Element => {
  const { spaceBetween, sidwallTyp } = useSidewall()

  return (
    <mesh castShadow position={[-sidwallTyp.log.depth + 0.02, 0.01, 0]}>
      <boxGeometry args={[0.02, 0.015, spaceBetween]} />
      <CachedMeshPhysicalMaterial color={'silver'} />
    </mesh>
  )
}
